/**
 * GA4 ecommerce via dataLayer (GTM já carrega no layout).
 * add_to_cart (Ajax), select_item, remove_from_cart, begin_checkout, promoções, wishlist.
 */

function getCurrency() {
  return document.documentElement.getAttribute('data-currency') || 'BRL';
}

function cartAddJsUrl(action) {
  if (!action) return '/cart/add.js';
  try {
    const u = new URL(action, window.location.origin);
    let path = u.pathname.replace(/\/$/, '');
    if (!path.endsWith('.js')) path += '.js';
    return path + u.search;
  } catch {
    return '/cart/add.js';
  }
}

/**
 * @param {Record<string, unknown>} line
 */
function lineItemToGaItem(line) {
  const priceRaw =
    line.final_price != null && line.final_price !== ''
      ? line.final_price
      : line.price != null && line.price !== ''
        ? line.price
        : 0;
  const priceCents =
    typeof priceRaw === 'string' ? parseInt(priceRaw, 10) : Number(priceRaw);
  const qty = typeof line.quantity === 'number' ? line.quantity : parseInt(String(line.quantity), 10) || 1;
  const sku = line.sku != null && String(line.sku).trim() ? String(line.sku) : '';
  const item = {
    item_id: sku || String(line.variant_id),
    item_name: String(line.product_title || ''),
    price: Number.isFinite(priceCents) ? priceCents / 100 : 0,
    quantity: qty,
  };
  const vt = line.variant_title;
  if (vt && vt !== 'Default Title') {
    item.item_variant = String(vt);
  }
  return item;
}

function onCartAddSubmit(e) {
  const form = e.target;
  if (!(form instanceof HTMLFormElement)) return;
  const action = form.getAttribute('action') || '';
  if (!action.includes('/cart/add')) return;
  e.preventDefault();

  const url = cartAddJsUrl(action);
  const fd = new FormData(form);

  fetch(url, {
    method: 'POST',
    body: fd,
    headers: { Accept: 'application/json' },
  })
    .then((res) => res.json().then((data) => ({ res, data })))
    .then(({ res, data }) => {
      if (!res.ok) {
        const msg =
          data && typeof data === 'object' && 'description' in data
            ? String(data.description)
            : '';
        if (msg) window.alert(msg);
        window.location.assign(form.action);
        return;
      }
      if (typeof window.zaryaGA4Push === 'function' && data && typeof data === 'object') {
        const item = lineItemToGaItem(data);
        const value = item.price * item.quantity;
        window.zaryaGA4Push('add_to_cart', {
          ecommerce: {
            currency: getCurrency(),
            value,
            items: [item],
          },
        });
      }
      window.dispatchEvent(
        new CustomEvent('zarya:cart:added', {
          detail: {
            item: data,
          },
        })
      );
    })
    .catch(() => {
      window.location.assign(form.action);
    });
}

document.addEventListener('submit', onCartAddSubmit, true);

function readListItemFromCard(card) {
  if (!card || !card.dataset) return null;
  const d = card.dataset;
  if (!d.gaItemId) return null;
  const item = {
    item_id: d.gaItemId,
    item_name: d.gaItemName || '',
    price: parseFloat(d.gaItemPrice) || 0,
    quantity: 1,
  };
  if (d.gaVariantTitle) item.item_variant = d.gaVariantTitle;
  const idx = parseInt(d.gaItemIndex, 10);
  if (Number.isFinite(idx)) item.index = idx;
  return {
    item_list_id: d.gaListId || '',
    item_list_name: d.gaListName || '',
    item,
  };
}

document.addEventListener('click', (e) => {
  const link = e.target.closest(
    'a.collection__card-link, a.search__card-link, a.product-carousel__card-link, a.collections-hero__card-link'
  );
  if (!link || typeof window.zaryaGA4Push !== 'function') return;
  const card = link.closest('[data-ga-item-id]');
  const parsed = readListItemFromCard(card);
  if (!parsed) return;
  const { item_list_id, item_list_name, item } = parsed;
  window.zaryaGA4Push('select_item', {
    ecommerce: {
      item_list_id,
      item_list_name,
      items: [item],
    },
  });
});

document.addEventListener('click', (e) => {
  const a = e.target.closest('a.cart__item-remove[data-ga-remove-item]');
  if (!a || typeof window.zaryaGA4Push !== 'function') return;
  const raw = a.getAttribute('data-ga-remove-item');
  if (!raw) return;
  let payload;
  try {
    payload = JSON.parse(raw);
  } catch {
    return;
  }
  const price = Number(payload.price) || 0;
  const qty = Number(payload.quantity) || 1;
  const item = {
    item_id: String(payload.item_id),
    item_name: String(payload.item_name || ''),
    price,
    quantity: qty,
  };
  if (payload.item_variant) item.item_variant = String(payload.item_variant);
  window.zaryaGA4Push('remove_from_cart', {
    ecommerce: {
      currency: getCurrency(),
      value: price * qty,
      items: [item],
    },
  });
});

document.addEventListener(
  'click',
  (e) => {
    const btn = e.target.closest('.cart__form button[name="checkout"], button.cart__checkout');
    if (!btn || !btn.closest('.cart__form') || typeof window.zaryaGA4Push !== 'function') return;
    const el = document.querySelector('[data-zarya-ga-checkout-payload]');
    if (!el || !el.textContent) return;
    try {
      const spec = JSON.parse(el.textContent.trim());
      window.zaryaGA4Push('begin_checkout', { ecommerce: spec });
    } catch {
      /* ignore */
    }
  },
  true
);

function promotionItemFromEl(el) {
  const d = el.dataset;
  return {
    promotion_id: d.gaPromotionId || '',
    promotion_name: d.gaPromotionName || '',
    creative_name: d.gaCreativeName || '',
    creative_slot: d.gaCreativeSlot || '',
  };
}

const viewedPromotions = new Set();

function initPromotionViews() {
  if (typeof window.zaryaGA4Push !== 'function') return;
  document.querySelectorAll('[data-hero-slide][data-ga-promotion-id]').forEach((slide) => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.2) return;
          const id = slide.getAttribute('data-ga-promotion-id');
          if (!id || viewedPromotions.has(id)) return;
          viewedPromotions.add(id);
          window.zaryaGA4Push('view_promotion', {
            ecommerce: { items: [promotionItemFromEl(slide)] },
          });
        });
      },
      { threshold: [0.2, 0.5] }
    );
    io.observe(slide);
  });
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.hero-banner__button');
  if (!btn || typeof window.zaryaGA4Push !== 'function') return;
  const ctx = btn.closest('[data-ga-promotion-id]');
  if (!ctx) return;
  window.zaryaGA4Push('select_promotion', {
    ecommerce: { items: [promotionItemFromEl(ctx)] },
  });
});

function wishlistItemFromPdp(btn) {
  const section = btn.closest('.product-section');
  if (!section) return null;
  const form = section.querySelector('[data-product-form]');
  const jsonEl = section.querySelector('[data-product-variants]');
  if (!form || !jsonEl) return null;
  const input = form.querySelector('[data-variant-input]');
  const vid = input ? input.value : '';
  let variants;
  try {
    variants = JSON.parse(jsonEl.textContent || '[]');
  } catch {
    return null;
  }
  const v = variants.find((x) => String(x.id) === String(vid));
  if (!v) return null;
  const sku = v.sku && String(v.sku).trim() ? String(v.sku) : String(v.id);
  const item = {
    item_id: sku,
    item_name: document.querySelector('.product-detail__title')?.textContent?.trim() || '',
    price: v.price / 100,
    quantity: 1,
  };
  if (v.title && v.title !== 'Default Title') item.item_variant = v.title;
  return item;
}

document.addEventListener('click', (e) => {
  const w = e.target.closest('[data-ga-wishlist]');
  if (w && typeof window.zaryaGA4Push === 'function') {
    const item = wishlistItemFromPdp(w);
    if (item) {
      window.zaryaGA4Push('add_to_wishlist', {
        ecommerce: {
          currency: getCurrency(),
          value: item.price,
          items: [item],
        },
      });
    }
    return;
  }

  const gridWish = e.target.closest(
    '.collection__wishlist, .search__wishlist, .collections-hero__wishlist, .product-carousel__wishlist'
  );
  if (!gridWish || typeof window.zaryaGA4Push !== 'function') return;
  const card = gridWish.closest('[data-ga-item-id]');
  const parsed = readListItemFromCard(card);
  if (!parsed) return;
  window.zaryaGA4Push('add_to_wishlist', {
    ecommerce: {
      currency: getCurrency(),
      value: parsed.item.price,
      items: [parsed.item],
    },
  });
});

function boot() {
  initPromotionViews();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
